import { SpecialOfferReceiptState } from '@/types/store'
import { GetSpecialOfferReceiptResponse } from '../../../api/@types'
import { MutationTree } from 'vuex'
import { SpecialOfferReceiptType } from '../../types/special-offer'

export const mutations: MutationTree<SpecialOfferReceiptState> = {
  setIsSpecialOfferReceiptLoading(state, isLoading: boolean) {
    state.isSpecialOfferReceiptLoading = isLoading
  },
  specialOfferReceiptLoaded(
    state,
    payload: [GetSpecialOfferReceiptResponse[], number],
  ) {
    state.specialOfferReceipts = payload[0]
    state.total = payload[1]
  },
  setSpecialOfferReceipt(
    state,
    specialOfferReceipt: GetSpecialOfferReceiptResponse,
  ) {
    state.specialOfferReceipt = specialOfferReceipt
  },
  setReceiptType(state, receiptType: SpecialOfferReceiptType): void {
    state.receiptType = receiptType
  },
}
